import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsDetailsRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-details',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
	exact: true,
};
